import CommunityGreetingImage_2x_namespaceObject from "../../static/image/CommunityGreetingImage@2x.png";
export default CommunityGreetingImage_2x_namespaceObject;
